export default "__VITE_ASSET__BXAZ94Y1__"